import React from 'react'
import Container from '../../components/Container';
import {Title, Center, Error, Description} from './styled';
import {BiError} from 'react-icons/bi';
import { Link } from 'react-router-dom';

const NotAfound: React.FC = () => {
    document.title = "Página não encontrada";

    return (
        <Container>
            <Center>      
                <BiError color={"#a29bfe"} size={100}/>  
                <span className="font-warning bold">{window.location.href}</span>
                <Error>404</Error>
                <Title>Não conseguimos encontrar essa página!</Title>
                <Description>Essa página parece não estar funcionando, ou não existe.<br/>Se você acha que isso é um erro, <Link to={`${process.env.PUBLIC_URL}/contato`}>entre em contato</Link>.</Description>
            </Center>
        </Container>
    )
}

export default NotAfound;